export default {
  'register.alert.confirm': 'กรุณายอมรับข้อกำหนดการใช้งานก่อนดำเนินการต่อ',
  'register.alert.register_fail': 'การลงทะเบียนไม่สำเร็จ กรุณาลองใหม่',
  'register.alert.phone_number.exists': 'หมายเลขโทรศัพท์นี้ถูกใช้แล้ว กรุณาใช้หมายเลขโทรศัพท์อื่น',
  'register.alert.phone_number.verify_fail':
    'การยืนยันหมายเลขโทรศัพท์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.email.exists': 'อีเมลนี้ถูกใช้แล้ว กรุณาใช้อีเมลอื่น',
  'register.alert.email.verify_fail': 'การยืนยันอีเมลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.birthday.verify_fail': 'การยืนยันวันเกิดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.gender.verify_fail': 'การยืนยันเพศไม่สำเร็จกรุณาลองใหม่อีกครั้ง ',
  'register.alert.city.verify_fail': 'การยืนยันที่อยู่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.job.verify_fail': 'การยืนยันอาชีพไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.education_level.verify_fail':
    'การยืนยันระดับการศึกษาไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.marriage.verify_fail': 'การยืนยันสถานภาพการสมรสไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.interest.verify_fail': 'การยืนยันความสนใจไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.diet.verify_fail': 'การยืนยันประเภทอาหารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง ',
  'register.alert.line_account.registered': 'บัญชี LINE นี้ถูกลงทะเบียนแล้ว',
  'register.alert.otp.verify_fail': 'การยืนยัน OTP ไม่สำเร็จ กรุณาลองใหม่',
  'register.alert.field_required': 'กรุณากรอกข้อมูลให้ครบถ้วน',
  'register.alert.referral_code': 'รหัสแนะนำเพื่อนที่กรอกไม่ถูกต้อง กรุณาตรวจสอบ!',
  'register.alert.please_select': 'กรุณาเลือกข้อมูล',
  'register.alert.number_required': 'กรุณากรอกตัวเลข',
  'register.alert.number_length': 'กรุณากรอกตัวเลขไม่เกิน 18 หลัก',
  'register.phone_number': 'หมายเลขโทรศัพท์',
  'register.phone_number.required': 'กรุณากรอกหมายเลขโทรศัพท์',
  'register.phone_number.format_error': 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง',
  'register.phone_number.not_match': 'หมายเลขโทรศัพท์ไม่ตรงกัน',
  'register.phone_number.enter_again': 'กรุณากรอกหมายเลขโทรศัพท์อีกครั้ง',
  'register.name': 'ชื่อ',
  'register.name.required': 'กรุณากรอกชื่อ',
  'register.name.format_error': 'กรุณากรอกเฉพาะตัวอักษรภาษาอังกฤษหรือตัวอักษรจีน',
  'register.birth': 'วันเกิด',
  'register.birth.required': 'กรุณากรอกวันเกิด',
  'register.email': 'อีเมล',
  'register.email.required': 'กรุณากรอกอีเมล',
  'register.email.format_error': 'รูปแบบอีเมลไม่ถูกต้อง',
  'register.gender': 'เพศ',
  'register.gender.required': 'กรุณาเลือกเพศ',
  'register.city': 'ที่อยู่',
  'register.city.required': 'กรุณาเลือกที่อยู่',
  'register.job': 'อาชีพ',
  'register.job.required': 'กรุณาเลือกอาชีพ',
  'register.eduction_level': 'ระดับการศึกษา',
  'register.eduction_level.required': 'กรุณาเลือกระดับการศึกษา',
  'register.marriage': 'สถานภาพการสมรส',
  'register.marriage.required': 'กรุณาเลือกสถานภาพการสมรส',
  'register.habit': 'ความสนใจ',
  'register.habit.required': 'กรุณาเลือกความสนใจ',
  'register.diet': 'ประเภทอาหาร',
  'register.diet.required': 'กรุณาเลือกประเภทอาหาร',
  'register.agree': 'ฉันยอมรับ',
  'register.term': 'ข้อกำหนดการใช้งาน',
  'register.privacy_policy': 'นโยบายความเป็นส่วนตัว',
  'register.account_verification': 'ยืนยันบัญชี',
  'register.member_information': 'ข้อมูลสมาชิก',
  'register.complete': 'ลงทะเบียนสำเร็จ',
  'register.submit': 'ส่งข้อมูล',
  'register.success': 'การลงทะเบียนสำเร็จ',
  'register.success_with_mgm':
    'ลงทะเบียนสำเร็จ! คุณจะได้รับรางวัลพิเศษสำหรับการลงทะเบียนภายใน 5 นาที',
  'register.country_code': 'รหัสประเทศ',
  'register.country_code.required': 'กรุณาเลือกรหัสประเทศ',
  'register.referral_code': 'รหัสแนะนำเพื่อน',
  'register.prev_step': 'ขั้นตอนก่อนหน้า',
  'register.next_step': 'ขั้นตอนถัดไป',
} as Record<string, string>;
